import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/views/401'),
    hidden: true,
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    hidden: true,
  },
  {
    path: '',
    name: '4041',
    component: () => import('@/views/404'),
    hidden: true,
  }
]
export const asyncRoutes = [

  // 数据大屏
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    permissions: true,
    children: [
      {
        path: '/index',
        permissions: true,
        name: 'Index',
        component: () => import('@/views/index/index'),
        meta: {
          title: '数据大屏',
          icon: 'icon-shuju1',
          affix: true,
        },
      },
    ]
  },

  // 商场管理
  {
    path: '/mall',
    permissions: true,
    component: Layout,
    name: 'mall',
    alwaysShow: true,
    meta: {
      title: '商场管理',
      icon: 'icon-shangchangguanli',
    },
    children: [
      {
        path: '/mall/index',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/mall/index',
        meta: {
          title: '商场列表',
        },
        children: [
          {
            path: '/mall/index',
            permissions: true,
            name: 'mallIndex',
            component: () => import('@/views/mall/list/index'),
            meta: {
              title: '商场列表',
            },
            hidden: true,
          },
        ]
      },
    ]
  },

  // 店铺管理
  {
    path: '/financeShop',
    permissions: true,
    component: Layout,
    name: 'financeShop',
    alwaysShow: true,
    meta: {
      title: '店铺管理',
      icon: 'icon-dianpu',
    },
    children: [
        {
        path: '/financeShop/index',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/member/index',
        meta: {
          title: '店铺列表',
        },
        children: [
          {
            path: '/financeShop/index',
            permissions: true,
            name: 'fShopIndex',
            component: () => import('@/views/finance/shop/index'),
            meta: {
              title: '店铺列表',
            },
            hidden: true
          },
          {
            path: '/financeShop/index/add',
            name: 'fShopAdd',
            component: () => import('@/views/finance/shop/add'),
            meta: {
              title: '录入店铺',
              activeMenu: '/financeShop/index',
            },
            hidden: true
          },
          {
            path: '/financeShop/index/detail',
            name: 'fShopDetail',
            component: () => import('@/views/finance/shop/detail'),
            meta: {
              title: '查看详情',
              activeMenu: '/financeShop/index',
            },
            hidden: true
          },
          {
            path: '/financeShop/index/setRate',
            name: 'setRate',
            component: () => import('@/views/finance/shop/setRate'),
            meta: {
              title: '设置费率',
              activeMenu: '/financeShop/index',
            },
            hidden: true
          },
          {
            path: '/financeShop/index/import',
            name: 'fShopImport',
            component: () => import('@/views/finance/shop/import'),
            meta: {
              title: '批量导入',
              activeMenu: '/financeShop/index',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/financeShop/shopCouponCode',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/financeShop/shopCouponCode',
        meta: {
          title: '店铺券码',
        },
        children: [
          {
            path: '/financeShop/shopCouponCode',
            permissions: true,
            name: 'fShopCouponCode',
            component: () => import('@/views/finance/shopCouponCode/index'),
            meta: {
              title: '店铺券码',
            },
            hidden: true,
          },
        ]
      },
    ]
  },

  // 会员管理
  {
    path: '/member',
    permissions: true,
    component: Layout,
    name: 'member',
    alwaysShow: true,
    meta: {
      title: '会员管理',
      icon: 'icon-huiyuan1',
    },
    children: [
      {
        path: '/member/index',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/member/index',
        meta: {
          title: '会员列表',
        },
        children: [
          {
            path: '/member/index',
            permissions: true,
            name: 'mIndex',
            component: () => import('@/views/memberManagement/list/index'),
            meta: {
              title: '会员列表',
            },
            hidden: true,
          },
          {
            path: '/member/index/detail',
            name: 'detail',
            component: () => import('@/views/memberManagement/list/detail'),
            meta: {
              title: '查看详情',
              activeMenu: '/member/index',
              breadcrumbTitle: '<span class="noblack">会员管理/会员列表<span class="black">/查看详情</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/member',
                name: '会员管理'
              },{
                class: 'noblack',
                path: '/member/index',
                name: '/会员列表'
              },{
                class: 'black',
                path: '/member/index/detail',
                name: '/查看详情',
              }]
            },
            hidden: true
          }
        ]
      },
      {
        path: '/member/label',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/member/label',
        meta: {
          title: '会员标签',
        },
        children: [
          {
            path: '/member/label',
            permissions: true,
            name: 'mLabel',
            component: () => import('@/views/memberManagement/label/index'),
            meta: {
              title: '会员标签',
            },
            hidden: true,
          },
          {
            path: '/member/label/create',
            name: 'labelCreate',
            component: () => import('@/views/memberManagement/label/create'),
            meta: {
              title: '创建标签',
              activeMenu: '/member/label',
              breadcrumbTitle: '<span class="noblack">会员管理/会员标签<span class="black">/创建标签</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/member',
                name: '会员管理',
              },{
                class: 'noblack',
                path: '/member/label',
                name: '/会员标签'
              },{
                class: 'black',
                path: '/member/label/create',
                name: '/创建标签',
                name1: '/编辑标签',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          }
        ]
      },
      {
        path: '/member/portrait',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/member/portrait',
        meta: {
          title: '会员画像',
        },
        children: [
          {
            path: '/member/portrait',
            permissions: true,
            name: 'mPortrait',
            component: () => import('@/views/memberManagement/portrait/index'),
            meta: {
              title: '会员画像',
            },
            hidden: true,
          },
          {
            path: '/member/portrait/create',
            name: 'portraitCreate',
            component: () => import('@/views/memberManagement/portrait/create'),
            meta: {
              title: '编辑画像',
              activeMenu: '/member/portrait',
              breadcrumbTitle: '<span class="noblack">会员管理/会员画像<span class="black">/编辑画像</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/member',
                name: '会员管理',
              },{
                class: 'noblack',
                path: '/member/portrait',
                name: '/会员画像'
              },{
                class: 'black',
                path: '/member/portrait/create',
                name: '/创建画像',
                name1: '/编辑画像',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          }
        ]
      },
      {
        path: '/member/equity',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/member/equity',
        meta: {
          title: '会员权益',
        },
        children: [
          {
            path: '/member/equity',
            permissions: true,
            name: 'mEquity',
            component: () => import('@/views/memberManagement/equity/index'),
            meta: {
              title: '会员权益',
            },
            hidden: true,
          },
          {
            path: '/member/equity/create',
            name: 'mEcreate',
            component: () => import('@/views/memberManagement/equity/create'),
            meta: {
              title: '编辑权益',
              activeMenu: '/member/equity',
              breadcrumbTitle: '<span class="noblack">会员管理/会员权益<span class="black">/编辑权益</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/member',
                name: '会员管理',
              },{
                class: 'noblack',
                path: '/member/equity',
                name: '/会员权益'
              },{
                class: 'black',
                path: '/member/equity/create',
                name: '/创建权益',
                name1: '/编辑权益',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          }
        ]
      },
      {
        path: '/member/grade',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '会员等级',
        },
        children: [
          {
            path: '/member/grade',
            permissions: true,
            name: 'mGrade',
            component: () => import('@/views/memberManagement/grade/index'),
            meta: {
              title: '会员等级',
            },
            hidden: true
          },
          {
            path: '/member/grade/add',
            name: 'mGradeAdd',
            component: () => import('@/views/memberManagement/grade/add'),
            meta: {
              title: '创建等级',
              activeMenu: '/member/grade',
              breadcrumbTitle: '<span class="noblack">会员管理/会员等级<span class="black">/创建等级</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/member',
                name: '会员管理',
              },{
                class: 'noblack',
                path: '/member/grade',
                name: '/会员权益'
              },{
                class: 'black',
                path: '/member/grade/add',
                name: '/创建等级',
                name1: '/编辑等级',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/member/sale/data',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '会员营销数据',
        },
        children: [
          {
            path: '/member/sale/data',
            permissions: true,
            name: 'marketingIndex',
            component: () => import('@/views/memberManagement/marketing/index'),
            meta: {
              title: '会员营销数据',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/member/levelRecord',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '等级调整记录',
        },
        children: [
          {
            path: '/member/levelRecord',
            permissions: true,
            name: 'mLevelRecord',
            component: () => import('@/views/memberManagement/levelRecord/index'),
            meta: {
              title: '等级调整记录',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/member/invitingFriendsRecord',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '邀友记录',
        },
        children: [
          {
            path: '/member/invitingFriendsRecord',
            permissions: true,
            name: 'mInvitingFriendsRecord',
            component: () => import('@/views/memberManagement/invitingFriendsRecord/index'),
            meta: {
              title: '邀友记录',
            },
            hidden: true
          },
        ]
      },
    ]
  },

  // 账号管理
  {
    path: '/permission/index',
    permissions: true,
    component: Layout,
    name: 'permission',
    // alwaysShow: true,
    meta: {
      title: '账号管理',
      icon: 'icon-quanxian1',
    },
    children: [
      {
        path: '/permission/index',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '账号列表',
        },
        hidden: true,
        children: [
          {
            path: '/permission/index',
            permissions: true,
            name: 'pIndex',
            component: () => import('@/views/permissionManagement/list/index'),
            meta: {
              activeMenu: '/permission/index'
            },
            hidden: true
          },
          {
            path: '/permission/index/add',
            name: 'permissionAdd',
            component: () => import('@/views/permissionManagement/list/add'),
            meta: {
              title: ' ',
              activeMenu: '/permission/index',
            },
            hidden: true,
          },
        ]
      },
    ],
  },

  // 积分管理
  {
    path: '/accumulationScore',
    permissions: true,
    component: Layout,
    name: 'accumulationScore',
    alwaysShow: true,
    meta: {
      title: '积分管理',
      icon: 'icon-jifen',
    },
    children: [
      {
        path: '/accumulationScore/rule',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '积分规则',
        },
        children: [
          {
            path: '/accumulationScore/rule',
            permissions: true,
            name: 'accumulationScoreRule',
            component: () => import('@/views/accumulationScore/rule/index'),
            meta: {
              title: '积分规则',
            },
            hidden: true
          },
          {
            path: '/accumulationScore/rule/add',
            permissions: false,
            name: 'accumulationScoreRuleAdd',
            component: () => import('@/views/accumulationScore/rule/add'),
            meta: {
              title: '添加积分规则',
              activeMenu: '/accumulationScore/rule',
              breadcrumbTitle: '<span class="noblack">积分管理/积分规则<span class="black">/添加积分规则</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/accumulationScore',
                name: '积分管理',
              },{
                class: 'noblack',
                path: '/accumulationScore/rule',
                name: '/积分规则',
              },{
                class: 'black',
                path: '/accumulationScore/rule/add',
                name: '/添加积分规则',
                name1: '/编辑积分规则',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/accumulationScore/task',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '积分任务',
        },
        children: [
          {
            path: '/accumulationScore/task',
            permissions: true,
            name: 'accTaskIndex',
            component: () => import('@/views/accumulationScore/task/index'),
            meta: {
              title: '积分任务',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/accumulationScore/flow',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '积分流水',
        },
        children: [
          {
            path: '/accumulationScore/flow',
            permissions: true,
            name: 'accFlowIndex',
            component: () => import('@/views/accumulationScore/flow/index'),
            meta: {
              title: '积分流水',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/accumulationScore/photograp',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '拍照积分',
        },
        children: [
          {
            path: '/accumulationScore/photograp',
            permissions: true,
            name: 'accPhotograpIndex',
            component: () => import('@/views/accumulationScore/photograp/index'),
            meta: {
              title: '拍照积分',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/accumulationScore/photocredits',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '拍照积分规则说明',
        },
        children: [
          {
            path: '/accumulationScore/photocredits',
            permissions: true,
            name: 'accPhotocreditsIndex',
            component: () => import('@/views/accumulationScore/photocredits/index'),
            meta: {
              title: '拍照积分规则说明',
            },
            hidden: true
          },
        ]
      },
    ]
  },
  // 积分管理
  {
    path: '/scoreShop',
    permissions: true,
    component: Layout,
    name: 'scoreShop',
    alwaysShow: true,
    meta: {
      title: '积分商城',
      icon: 'icon-jifenshangcheng',
    },
    children: [
      {
        path: '/scoreShop/index',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '商城列表',
        },
        children: [
          {
            path: '/scoreShop/index',
            permissions: true,
            name: 'scoreShopIndex',
            component: () => import('@/views/scoreShop/index'),
            meta: {
              title: '商城列表',
            },
            hidden: true
          },
          {
            path: '/scoreShop/index/add',
            permissions: false,
            name: 'scoreShopIndexAdd',
            component: () => import('@/views/scoreShop/add'),
            meta: {
              title: '上架',
              activeMenu: '/scoreShop/index',
              breadcrumbTitle: '<span class="noblack">积分商城/商城列表<span class="black">/上架</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/scoreShop',
                name: '积分商城',
              },{
                class: 'noblack',
                path: '/scoreShop/index',
                name: '/商城列表',
              },{
                class: 'black',
                path: '/scoreShop/index/add',
                name: '/上架',
                name1: '/查看详情',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
    ]
  },
  // 储值卡商城
  {
    path: '/valueCardStore',
    permissions: true,
    component: Layout,
    name: 'valueCardStore',
    alwaysShow: true,
    meta: {
      title: '储值卡商城',
      icon: 'icon-chuzhiqia',
    },
    children: [
      {
        path: '/valueCardStore/list',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/valueCardStore/list',
        meta: {
          title: '商城列表',
        },
        children: [
          {
            path: '/valueCardStore/list',
            permissions: true,
            name: 'vcsListIndex',
            component: () => import('@/views/valueCardStore/list/index'),
            meta: {
              title: '商城列表',
            },
            hidden: true
          },
          {
            path: '/valueCardStore/list/add',
            name: 'mvcsAdd',
            component: () => import('@/views/valueCardStore/list/add'),
            meta: {
              title: '创建',
              activeMenu: '/valueCardStore/list',
              breadcrumbTitle: '<span class="noblack">储值卡商城/商城列表<span class="black">/创建</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/valueCardStore',
                name: '储值卡商城',
              },{
                class: 'noblack',
                path: '/valueCardStore/list',
                name: '/商城列表'
              },{
                class: 'black',
                path: '/valueCardStore/list/add',
                name: '/创建',
              }]
            },
            hidden: true
          },
          {
            path: '/valueCardStore/list/detail',
            name: 'mvcsDetail',
            component: () => import('@/views/valueCardStore/list/detail'),
            meta: {
              title: '查看详情',
              activeMenu: '/valueCardStore/list',
              breadcrumbTitle: '<span class="noblack">储值卡商城/商城列表<span class="black">/查看详情</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/valueCardStore',
                name: '储值卡商城',
              },{
                class: 'noblack',
                path: '/valueCardStore/list',
                name: '/商城列表'
              },{
                class: 'black',
                path: '/valueCardStore/list/detail',
                name: '/查看详情',
              }]
            },
            hidden: true
          },
        ]
      },
    ]
  },
  // 交易管理
  {
    path: '/finance',
    permissions: true,
    component: Layout,
    name: 'finance',
    alwaysShow: true,
    meta: {
      title: '交易管理',
      icon: 'icon-caiwu2',
    },
    children: [
      {
        path: '/finance/reconciliationCenter',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '对账中心',
        },
        children: [
          {
            path: '/finance/reconciliationCenter',
            permissions: true,
            name: 'fReconciliationCenter',
            component: () => import('@/views/finance/reconciliationCenter/index'),
            meta: {
              title: '对账中心',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/finance/index',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '财务概况',
        },
        // 需展示 hidden为false
        hidden: true,
        children: [
          {
            path: '/finance/index',
            permissions: true,
            name: 'fIndex',
            component: () => import('@/views/finance/survey/index'),
            meta: {
              title: '财务概况',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/finance/reconciliation',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '对账列表',
        },
        // 需展示 hidden为false
        // hidden: true,
        children: [
          {
            path: '/finance/reconciliation',
            permissions: true,
            name: 'fReconciliation',
            component: () => import('@/views/finance/reconciliation/index'),
            meta: {
              title: '对账列表',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/finance/subsidyreview',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '补贴款审核',
        },
        // 需展示 hidden为false
        // hidden: true,
        children: [
          {
            path: '/finance/subsidyreview',
            permissions: true,
            name: 'fSubsidyreview',
            component: () => import('@/views/finance/subsidyreview/index'),
            meta: {
              title: '补贴款审核',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/finance/order',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        name: 'order',
        meta: {
          title: '订单列表',
        },
        children: [
          {
            path: '/finance/order',
            permissions: true,
            component: {
              render (c) {
                return c('router-view')
              }
            },
            meta: {
              title: '订单列表',
            },
            hidden: true,
            children: [
              {
                path: '/finance/order',
                permissions: true,
                name: 'orderIndex',
                component: () => import('@/views/order/list/index'),
                meta: {
                  activeMenu: '/finance/order'
                },
                hidden: true
              },
              {
                path: '/finance/order/detail',
                name: 'orderDetail',
                component: () => import('@/views/order/list/detail'),
                meta: {
                  title: '查看详情',
                  activeMenu: '/finance/order',
                },
                hidden: true
              },
            ]
          },
        ]
      },
      {
        path: '/finance/management',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '财务管理',
        },
        children: [
          {
            path: '/finance/management',
            permissions: true,
            name: 'management',
            component: () => import('@/views/finance/management/index'),
            meta: {
              title: '财务管理',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/finance/settlement',
        permissions: false,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '结算管理',
        },
        children: [
          {
            path: '/finance/settlement',
            permissions: false,
            name: 'settlement',
            component: () => import('@/views/finance/settlement/index'),
            meta: {
              title: '结算管理',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/finance/refundapproval',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '退款查询',
        },
        children: [
          {
            path: '/finance/refundapproval',
            permissions: true,
            name: 'fRefundapproval',
            component: () => import('@/views/finance/refundapproval/index'),
            meta: {
              title: '退款查询',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/finance/refundapply',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '退款审核',
        },
        children: [
          {
            path: '/finance/refundapply',
            permissions: true,
            name: 'fRefundReview',
            component: () => import('@/views/finance/refundReview/index'),
            meta: {
              title: '退款审核',
            },
            hidden: true
          },
        ]
      }
    ],
  },
  // 停车管理
  {
    path: '/parkManagement',
    permissions: true,
    component: Layout,
    name: 'parkMangement',
    alwaysShow: true,
    meta: {
      title: '停车管理',
      icon: 'icon-tingcheguanli',
    },
    hidden: false,
    children: [
      {
        path: '/parkMangement/paymentRecord',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '缴费记录',
        },
        children: [
          {
            path: '/parkMangement/paymentRecord',
            permissions: true,
            name: 'PpaymentRecord',
            component: () => import('@/views/parking/record/index'),
            meta: {
              title: '缴费记录',
            },
            hidden: false,
          },
          {
            path: '/parkMangement/paymentRecord/detail',
            name: 'PpaymentRecordDetail',
            component: () => import('@/views/parking/record/detail'),
            meta: {
              title: '查看详情',
              activeMenu: '/parkMangement/paymentRecord',
              breadcrumbTitle: '<span class="noblack">停车管理/缴费记录<span class="black">/查看详情</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/parkManagement',
                name: '停车管理',
              },{
                class: 'noblack',
                path: '/parkMangement/paymentRecord',
                name: '/缴费记录'
              },{
                class: 'black',
                path: '/parkMangement/paymentRecord/detail',
                name: '/查看详情',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: false
              }]
            },
            hidden: true
          }
        ]
      },
      {
        path: '/parkMangement/orderDetails',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '订单明细',
        },
        children: [
          {
            path: '/parkMangement/orderDetails',
            permissions: true,
            name: 'orderDetails',
            component: () => import('@/views/parking/orderDetails/index'),
            meta: {
              title: '订单明细',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/parkMangement/invoiceControl',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '发票说明',
        },
        children: [
          {
            path: '/parkMangement/invoiceControl',
            permissions: true,
            name: 'invoiceControl',
            component: () => import('@/views/parking/invoiceControl/index'),
            meta: {
              title: '发票说明',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/parkMangement/question',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '常见问题',
        },
        children: [
          {
            path: '/parkMangement/question',
            permissions: true,
            name: 'question',
            component: () => import('@/views/parking/question/index'),
            meta: {
              title: '常见问题',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/parkMangement/invoiceList',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '发票列表',
        },
        children: [
          {
            path: '/parkMangement/invoiceList',
            permissions: true,
            name: 'invoiceList',
            component: () => import('@/views/parking/invoiceList/index'),
            meta: {
              title: '发票列表',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/parkMangement/config',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '停车配置',
        },
        children: [
          {
            path: '/parkMangement/config',
            permissions: true,
            name: 'parkConfig',
            component: () => import('@/views/parking/config/index'),
            meta: {
              title: '停车配置',
            },
            hidden: false,
          },
          {
            path: '/parkMangement/config/detail',
            name: 'PConfigDetail',
            component: () => import('@/views/parking/config/detail'),
            meta: {
              title: '查看详情',
              activeMenu: '/parkMangement/config',
              breadcrumbTitle: '<span class="noblack">停车管理/停车配置<span class="black">/新增规则</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/parkMangement',
                name: '停车管理',
              },{
                class: 'noblack',
                path: '/parkMangement/config',
                name: '/停车配置'
              },{
                class: 'black',
                path: '/parkMangement/config/detail',
                name: '/新增规则',
                name1: '/编辑规则',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
          {
            path: '/parkMangement/config/detail2',
            name: 'PConfigDetail2',
            component: () => import('@/views/parking/config/detail'),
            meta: {
              title: '查看详情',
              activeMenu: '/parkMangement/config',
              breadcrumbTitle: '<span class="noblack">停车管理/停车配置<span class="black">/查看详情</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/parkMangement',
                name: '停车管理',
              },{
                class: 'noblack',
                path: '/parkMangement/config',
                name: '/停车配置'
              },{
                class: 'black',
                path: '/parkMangement/config/detail2',
                name: '/查看详情',
              }]
            },
            hidden: true
          }
        ]
      },
    ],
  },
  // 营销管理
  {
    path: '/market',
    permissions: true,
    component: Layout,
    name: 'market',
    alwaysShow: true,
    meta: {
      title: '营销管理',
      icon: 'icon-yingxiao',
    },
    children: [
      {
        path: '/market/welfareCouponList',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/welfareCouponList',
        meta: {
          title: '供应权益列表',
        },
        children: [
          {
            path: '/market/welfareCouponList',
            permissions: true,
            name: 'marketWelfareCouponListIndex',
            component: () => import('@/views/market/welfareCouponList/index'),
            meta: {
              title: '供应权益列表',
            },
            hidden: false
          },
          {
            path: '/market/welfareCouponList/create',
            name: 'mwcreate',
            component: () => import('@/views/market/welfareCouponList/create'),
            meta: {
              title: '编辑供应权益',
              activeMenu: '/market/welfareCouponList',
              breadcrumbTitle: '<span class="noblack">营销管理/供应权益列表<span class="black">/编辑供应权益</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/welfareCouponList',
                name: '/供应权益列表'
              },{
                class: 'black',
                path: '/market/welfareCouponList/create',
                name: '/创建供应权益',
                name1: '/编辑供应权益',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/welfareCouponPayRecord',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/welfareCouponPayRecord',
        meta: {
          title: '供应商券购买记录',
        },
        children: [
          {
            path: '/market/welfareCouponPayRecord',
            permissions: true,
            name: 'welfareCouponPayRecord',
            component: () => import('@/views/market/welfareCouponPayRecord/index'),
            meta: {
              title: '供应商券购买记录',
            },
            hidden: false
          }
        ]
      },
      {
        path: '/market/deductionList',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/deductionList',
        meta: {
          title: '抵扣券列表',
        },
        // 展示时 hidden 删除
        // hidden: true,
        children: [
          {
            path: '/market/deductionList',
            permissions: true,
            name: 'marketDeductionListIndex',
            component: () => import('@/views/market/deductionList/index'),
            meta: {
              title: '抵扣券列表',
            },
            hidden: true
          },
          {
            path: '/market/deductionList/create',
            name: 'marketDeductionListCreate',
            component: () => import('@/views/market/deductionList/create'),
            meta: {
              title: '创建抵扣券',
              activeMenu: '/market/deductionList',
              breadcrumbTitle: '<span class="noblack">营销管理/抵扣列表<span class="black">/创建抵扣券</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/deductionList',
                name: '/抵扣券列表'
              },{
                class: 'black',
                path: '/market/deductionList/create',
                name: '/创建抵扣券',
                name1: '/编辑抵扣券',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/deductionRecord',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/deductionRecord',
        meta: {
          title: '抵扣券记录',
        },
        children: [
          {
            path: '/market/deductionRecord',
            permissions: true,
            name: 'mcheckIndex',
            component: () => import('@/views/market/deductionRecord/index'),
            meta: {
              title: '抵扣券记录',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/couponList',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/couponList',
        meta: {
          title: '优惠券列表',
        },
        // 展示时 hidden 删除
        // hidden: true,
        children: [
          {
            path: '/market/couponList',
            permissions: true,
            name: 'marketCouponListIndex',
            component: () => import('@/views/market/couponList/index'),
            meta: {
              title: '优惠券列表',
            },
            hidden: true
          },
          {
            path: '/market/couponList/create',
            name: 'mccreate',
            component: () => import('@/views/market/couponList/create'),
            meta: {
              title: '创建优惠券',
              activeMenu: '/market/couponList',
              breadcrumbTitle: '<span class="noblack">营销管理/优惠券列表<span class="black">/创建优惠券</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/couponList',
                name: '/优惠券列表'
              },{
                class: 'black',
                path: '/market/couponList/create',
                name: '/创建优惠券',
                name1: '/编辑优惠券',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
          {
            path: '/market/couponList/codeStore',
            name: 'marketCouponListCodeStoreIndex',
            component: () => import('@/views/market/couponList/codeStore'),
            meta: {
              title: '查看码库',
              activeMenu: '/market/couponList',
              breadcrumbTitle: '<span class="noblack">营销管理/优惠券列表<span class="black">/查看码库</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/couponList',
                name: '/优惠券列表'
              },{
                class: 'black',
                path: '/market/couponList/codeStore',
                name: '/查看码库',
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/checkCancelRecord',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/checkCancelRecord',
        meta: {
          title: '优惠券记录',
        },
        children: [
          {
            path: '/market/checkCancelRecord',
            permissions: true,
            name: 'mcheckIndex',
            component: () => import('@/views/market/checkCancelRecord/index'),
            meta: {
              title: '优惠券记录',
            },
            hidden: true
          },
        ]
      },

      {
        path: '/market/giftCouponList',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/giftCouponList',
        meta: {
          title: '礼品券列表',
        },
        children: [
          {
            path: '/market/giftCouponList',
            permissions: true,
            name: 'marketGiftCouponListIndex',
            component: () => import('@/views/market/giftCouponList/index'),
            meta: {
              title: '礼品券列表',
            },
            hidden: true
          },
          {
            path: '/market/giftCouponList/add',
            name: 'marketGiftCouponListAdd',
            component: () => import('@/views/market/giftCouponList/add'),
            meta: {
              title: '创建礼品券',
              activeMenu: '/market/giftCouponList',
              breadcrumbTitle: '<span class="noblack">营销管理/礼品券列表<span class="black">/创建券列表</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/giftCouponList',
                name: '/礼品券列表'
              },{
                class: 'black',
                path: '/market/giftCouponList/add',
                name: '/创建礼品券',
                name1: '/编辑礼品券',
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/giftCouponRecord',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/giftCouponRecord',
        meta: {
          title: '礼品券记录',
        },
        children: [
          {
            path: '/market/giftCouponRecord',
            permissions: true,
            name: 'mGiftCouponRecordIndex',
            component: () => import('@/views/market/giftCouponRecord/index'),
            meta: {
              title: '礼品券记录',
            },
            hidden: true
          },
        ]
      },

      {
        path: '/market/parkingCouponList',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/parkingCouponList',
        meta: {
          title: '停车券列表',
        },
        children: [
          {
            path: '/market/parkingCouponList',
            permissions: true,
            name: 'marketParkingCouponListIndex',
            component: () => import('@/views/market/parkingCouponList/index'),
            meta: {
              title: '停车券列表',
            },
            hidden: true
          },
          {
            path: '/market/parkingCouponList/add',
            name: 'marketParkingCouponListAdd',
            component: () => import('@/views/market/parkingCouponList/add'),
            meta: {
              title: '创建停车券',
              activeMenu: '/market/parkingCouponList',
              breadcrumbTitle: '<span class="noblack">营销管理/停车券列表<span class="black">/创建券列表</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/parkingCouponList',
                name: '/停车券列表'
              },{
                class: 'black',
                path: '/market/parkingCouponList/add',
                name: '/创建停车券',
                name1: '/编辑停车券',
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/parkingCouponRecord',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/parkingCouponRecord',
        meta: {
          title: '停车券记录',
        },
        children: [
          {
            path: '/market/parkingCouponRecord',
            permissions: true,
            name: 'mParkingCouponRecordIndex',
            component: () => import('@/views/market/parkingCouponRecord/index'),
            meta: {
              title: '停车券记录',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/couponCenterPlatform',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/couponCenterPlatform',
        meta: {
          title: '券中台数据',
        },
        children: [
          {
            path: '/market/couponCenterPlatform',
            permissions: true,
            name: 'mCuponCenterPlatformIndex',
            component: () => import('@/views/market/couponCenterPlatform/index'),
            meta: {
              title: '券中台数据',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/couponGrant',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/couponGrant',
        meta: {
          title: '手动发券',
        },
        // hidden: true,
        children: [
          {
            path: '/market/couponGrant',
            permissions: true,
            name: 'marketCouponGrantIndex',
            component: () => import('@/views/market/couponGrant/index'),
            meta: {
              title: '手动发券列表',
            },
            hidden: true
          },
          {
            path: '/market/couponGrant/add',
            name: 'marketCouponGrantAdd',
            component: () => import('@/views/market/couponGrant/add'),
            meta: {
              title: '发券',
              activeMenu: '/market/couponGrant',
              breadcrumbTitle: '<span class="noblack">营销管理/手动发券列表<span class="black">/发券</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/couponGrant',
                name: '/手动发券列表'
              },{
                class: 'black',
                path: '/market/couponGrant/add',
                name: '/发券',
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/couponGrant-account',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/couponGrant-account',
        meta: {
          title: '可选优惠券',
        },
        children: [
          {
            path: '/market/couponGrant-account',
            permissions: true,
            name: 'mcgaIndex',
            component: () => import('@/views/market/couponGrant-account/index'),
            meta: {
              title: '可选优惠券',
            },
            hidden: true
          },
          {
            path: '/market/couponGrant-account/add',
            name: 'mcgaAdd',
            component: () => import('@/views/market/couponGrant-account/add'),
            meta: {
              title: '发券',
              activeMenu: '/market/couponGrant-account',
              breadcrumbTitle: '<span class="noblack">营销管理/可选优惠券<span class="black">/发券</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/couponGrant-account',
                name: '/可选优惠券'
              },{
                class: 'black',
                path: '/market/couponGrant-account/add',
                name: '/发券',
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/valueCard',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/valueCard',
        meta: {
          title: '储值卡',
        },
        children: [
          {
            path: '/market/valueCard',
            permissions: true,
            name: 'mvcIndex',
            component: () => import('@/views/market/valueCard/index'),
            meta: {
              title: '储值卡',
            },
            hidden: true
          },
          {
            path: '/market/valueCard/add',
            name: 'mvcAdd',
            component: () => import('@/views/market/valueCard/add'),
            meta: {
              title: '创建储值卡',
              activeMenu: '/market/valueCard',
              breadcrumbTitle: '<span class="noblack">营销管理/储值卡<span class="black">/创建储值卡</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/valueCard',
                name: '/储值卡'
              },{
                class: 'black',
                path: '/market/valueCard/add',
                name: '/创建储值卡',
              }]
            },
            hidden: true
          },
          {
            path: '/market/valueCard/detail',
            name: 'mvcDetail',
            component: () => import('@/views/market/valueCard/detail'),
            meta: {
              title: '查看详情',
              activeMenu: '/market/valueCard',
              breadcrumbTitle: '<span class="noblack">营销管理/储值卡<span class="black">/查看详情</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/valueCard',
                name: '/储值卡'
              },{
                class: 'black',
                path: '/market/valueCard/detail',
                name: '/查看详情',
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/valueCardReconciliation',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/valueCardReconciliation',
        meta: {
          title: '储值卡-对账中心',
        },
        children: [
          {
            path: '/market/valueCardReconciliation',
            permissions: true,
            name: 'mvcIndex1',
            component: () => import('@/views/market/valueCardReconciliation/index'),
            meta: {
              title: '储值卡-对账中心',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/ActivityList',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/ActivityList',
        meta: {
          title: '活动列表',
        },
        // 展示时 hidden 删除
        // hidden: true,
        children: [
          {
            path: '/market/ActivityList',
            permissions: true,
            name: 'marketActivityListIndex',
            component: () => import('@/views/market/activityList/index'),
            meta: {
              title: '活动列表',
            },
            hidden: true
          },
          {
            path: '/market/ActivityList/select',
            name: 'marketActivityListSelect',
            component: () => import('@/views/market/activityList/select'),
            meta: {
              title: '选择活动',
              activeMenu: '/market/ActivityList',
              breadcrumbTitle: '<span class="noblack">营销管理/活动列表<span class="black">/选择活动</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/ActivityList',
                name: '/活动列表'
              },{
                class: 'black',
                path: '/market/ActivityList/select',
                name: '/选择活动',
              }]
            },
            hidden: true
          },
          {
            path: '/market/ActivityList/add',
            name: 'marketActivityListAdd',
            component: () => import('@/views/market/activityList/lottery-roulette/add'),
            meta: {
              title: '创建活动',
              activeMenu: '/market/ActivityList',
              breadcrumbTitle: '<span class="noblack">营销管理/活动列表/选择活动<span class="black">/创建活动</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/ActivityList',
                name: '/活动列表'
              },{
                class: 'noblack',
                path: '/market/ActivityList/select',
                name: '/选择活动'
              },{
                class: 'black',
                path: '/market/ActivityList/add',
                name: '/创建活动',
                name1: '/查看活动',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
          {
            path: '/market/ActivityList/addCouponCenter',
            name: 'marketActivityListAddCC',
            component: () => import('@/views/market/activityList/getCouponCenter/add'),
            meta: {
              title: '创建活动',
              activeMenu: '/market/ActivityList',
              breadcrumbTitle: '<span class="noblack">营销管理/活动列表/选择活动<span class="black">/创建领券中心</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/ActivityList',
                name: '/活动列表'
              },{
                class: 'noblack',
                path: '/market/ActivityList/select',
                name: '/选择活动'
              },{
                class: 'black',
                path: '/market/ActivityList/addCouponCenter',
                name: '/创建领券中心',
                name1: '/查看领券中心',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
          {
            path: '/market/ActivityList/addCouponSell',
            name: 'marketActivityListAddCC1',
            component: () => import('@/views/market/activityList/couponSell/add'),
            meta: {
              title: '创建活动',
              activeMenu: '/market/ActivityList',
              breadcrumbTitle: '<span class="noblack">营销管理/活动列表/选择活动<span class="black">/售券</span></span>',
              breadcrumbPathArr: [
                { name: '营销管理', class: 'noblack', path: '/market' },
                { name: '/活动列表', class: 'noblack', path: '/market/ActivityList' },
                { name: '/选择活动', class: 'noblack', path: '/market/ActivityList/select' },
                { name: '/售券', class: 'black', path: '/market/ActivityList/addCouponSell' }
              ]
            },
            hidden: true
          },
          {
            path: '/market/ActivityList/addActivityApply',
            name: 'marketActivityAA',
            component: () => import('@/views/market/activityList/activityApply/add'),
            meta: {
              title: '创建活动',
              activeMenu: '/market/ActivityList',
              breadcrumbTitle: '<span class="noblack">营销管理/活动列表/选择活动<span class="black">/活动报名</span></span>',
              breadcrumbPathArr: [
                { name: '营销管理', class: 'noblack', path: '/market' },
                { name: '/活动列表', class: 'noblack', path: '/market/ActivityList' },
                { name: '/选择活动', class: 'noblack', path: '/market/ActivityList/select' },
                { name: '/活动报名', class: 'black', path: '/market/ActivityList/addActivityApply' }
              ]
            },
            hidden: true
          },
          {
            path: '/market/ActivityList/addSendCoupon',
            name: 'marketActivitySendCouponAdd',
            component: () => import('@/views/market/activityList/sendCoupon/add'),
            meta: {
              title: '发券活动',
              activeMenu: '/market/ActivityList',
              breadcrumbTitle: '<span class="noblack">营销管理/活动列表/选择活动<span class="black">/发券活动</span></span>',
              breadcrumbPathArr: [
                { name: '营销管理', class: 'noblack', path: '/market' },
                { name: '/活动列表', class: 'noblack', path: '/market/ActivityList' },
                { name: '/选择活动', class: 'noblack', path: '/market/ActivityList/select' },
                { name: '/发券活动', class: 'black', path: '/market/ActivityList/addSendCoupon' }
              ]
            },
            hidden: true
          },
          {
            path: '/market/ActivityList/addSeckill',
            name: 'marketActivitySeckillAdd',
            component: () => import('@/views/market/activityList/seckill/add'),
            meta: {
              title: '秒杀',
              activeMenu: '/market/ActivityList',
              breadcrumbTitle: '<span class="noblack">营销管理/活动列表/选择活动<span class="black">/秒杀</span></span>',
              breadcrumbPathArr: [
                { name: '营销管理', class: 'noblack', path: '/market' },
                { name: '/活动列表', class: 'noblack', path: '/market/ActivityList' },
                { name: '/选择活动', class: 'noblack', path: '/market/ActivityList/select' },
                { name: '/秒杀', class: 'black', path: '/market/ActivityList/addSeckill' }
              ]
            },
            hidden: true
          },
          {
            path: '/market/ActivityList/detail',
            name: 'marketActivityListDetail',
            component: () => import('@/views/market/activityList/detail'),
            meta: {
              title: '查看详情',
              activeMenu: '/market/ActivityList',
              breadcrumbTitle: '<span class="noblack">营销管理/活动列表<span class="black">/查看详情</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/market',
                name: '营销管理',
              },{
                class: 'noblack',
                path: '/market/ActivityList',
                name: '/活动列表'
              },{
                class: 'black',
                path: '/market/ActivityList/detail',
                name: '/查看详情',
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/writeOffList',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/writeOffList',
        meta: {
          title: '奖品核销记录',
        },
        // 展示时 hidden 删除
        // hidden: true,
        children: [
          {
            path: '/market/writeOffList',
            permissions: true,
            name: 'marketWriteOffListIndex',
            component: () => import('@/views/market/writeOffList/index'),
            meta: {
              title: '奖品核销记录',
            },
            hidden: true
          },
        ]
      },
      {
        path: '/market/invitingFriends',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        redirect: '/market/invitingFriends',
        meta: {
          title: '邀友活动',
        },
        // 展示时 hidden 删除
        // hidden: true,
        children: [
          {
            path: '/market/invitingFriends',
            permissions: true,
            name: 'marketInvitingFriendsIndex',
            component: () => import('@/views/market/invitingFriends/index'),
            meta: {
              title: '邀友活动',
            },
            hidden: true
          },
        ]
      }
    ]
  },

  // 服务配置
  {
    path: '/serverConfig',
    permissions: true,
    component: Layout,
    name: 'serverConfig',
    alwaysShow: true,
    meta: {
      title: '服务配置',
      icon: 'icon-fuwu',
    },
    children: [
      {
        path: '/serverConfig/pageConfig',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '页面配置',
        },
        children: [
          {
            path: '/serverConfig/pageConfig',
            permissions: true,
            name: 'SCPageConfig',
            component: () => import('@/views/serverConfig/pageConfig/index'),
            meta: {
              title: '页面配置',
            },
            hidden: true
          },
          {
            path: '/serverConfig/pageConfig/add',
            name: 'SCPageConfigAdd',
            component: () => import('@/views/serverConfig/pageConfig/add'),
            meta: {
              title: '创建页面配置',
              activeMenu: '/serverConfig/pageConfig',
              breadcrumbTitle: '<span class="noblack">服务配置/页面配置<span class="black">/创建页面配置</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/serverConfig',
                name: '服务配置',
              },{
                class: 'noblack',
                path: '/serverConfig/pageConfig',
                name: '/页面配置'
              },{
                class: 'black',
                path: '/serverConfig/pageConfig/add',
                name: '/新增',
                name1: '/编辑',
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/serverConfig/bannerList',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '广告列表',
        },
        children: [
          {
            path: '/serverConfig/bannerList',
            permissions: true,
            name: 'SCBannerList',
            component: () => import('@/views/serverConfig/bannerList/index'),
            meta: {
              title: '广告列表',
            },
            hidden: true
          },
          {
            path: '/serverConfig/bannerList/add',
            name: 'SCBCreate',
            component: () => import('@/views/serverConfig/bannerList/add'),
            meta: {
              title: '创建Banner',
              activeMenu: '/serverConfig/bannerList',
              breadcrumbTitle: '<span class="noblack">服务配置/广告列表<span class="black">/创建Banner</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/serverConfig',
                name: '服务配置',
              },{
                class: 'noblack',
                path: '/serverConfig/bannerList',
                name: '/广告列表'
              },{
                class: 'black',
                path: '/serverConfig/bannerList/add',
                name: '/创建',
                name1: '/编辑',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/serverConfig/info',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '信息专栏',
        },
        children: [
          {
            path: '/serverConfig/info',
            permissions: true,
            name: 'SCInfo',
            component: () => import('@/views/serverConfig/info/index'),
            meta: {
              title: '信息专栏',
            },
            hidden: true
          },
          {
            path: '/serverConfig/info/add',
            name: 'SCICreate',
            component: () => import('@/views/serverConfig/info/add'),
            meta: {
              title: '创建信息',
              activeMenu: '/serverConfig/info',
              breadcrumbTitle: '<span class="noblack">服务配置/信息专栏<span class="black">/创建信息</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/serverConfig',
                name: '服务配置',
              },{
                class: 'noblack',
                path: '/serverConfig/info',
                name: '/信息专栏'
              },{
                class: 'black',
                path: '/serverConfig/info/add',
                name: '/创建信息',
                name1: '/编辑信息',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/serverConfig/businessIntroduce',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '商场介绍',
        },
        children: [
          {
            path: '/serverConfig/businessIntroduce',
            permissions: true,
            name: 'SCBusinessIntroduce',
            component: () => import('@/views/serverConfig/businessIntroduce/index'),
            meta: {
              title: '商场介绍',
            },
            hidden: true
          },
          {
            path: '/serverConfig/businessIntroduce/add',
            name: 'SCBusinessIntroduceAdd',
            component: () => import('@/views/serverConfig/businessIntroduce/add'),
            meta: {
              title: '创建商场介绍',
              activeMenu: '/serverConfig/businessIntroduce',
              breadcrumbTitle: '<span class="noblack">服务配置/商场介绍<span class="black">/创建商场介绍</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/serverConfig',
                name: '服务配置',
              },{
                class: 'noblack',
                path: '/serverConfig/businessIntroduce',
                name: '/商场介绍'
              },{
                class: 'black',
                path: '/serverConfig/businessIntroduce/add',
                name: '/创建商场介绍',
                name1: '/编辑商场介绍',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/serverConfig/posterList',
        permissions: true,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '活动页',
        },
        children: [
          {
            path: '/serverConfig/posterList',
            permissions: true,
            name: 'SCPosterListList',
            component: () => import('@/views/serverConfig/posterList/index'),
            meta: {
              title: '活动页',
            },
            hidden: true
          },
          {
            path: '/serverConfig/posterList/add',
            name: 'SCPosterListAdd',
            component: () => import('@/views/serverConfig/posterList/add'),
            meta: {
              title: '创建商场介绍',
              activeMenu: '/serverConfig/posterList',
              breadcrumbTitle: '<span class="noblack">服务配置/活动页<span class="black">/创建活动页</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/serverConfig',
                name: '服务配置',
              },{
                class: 'noblack',
                path: '/serverConfig/posterList',
                name: '/活动页'
              },{
                class: 'black',
                path: '/serverConfig/posterList/add',
                name: '/创建活动页',
                name1: '/编辑活动页',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
      {
        path: '/serverConfig/writeoffAccount',
        permissions: false,
        component: {
          render (c) {
            return c('router-view')
          }
        },
        meta: {
          title: '核销账户',
        },
        children: [
          {
            path: '/serverConfig/writeoffAccount',
            permissions: false,
            name: 'SCWriteoffAccount',
            component: () => import('@/views/serverConfig/writeoffAccount/index'),
            meta: {
              title: '核销账户',
            },
            hidden: true
          },
          {
            path: '/serverConfig/writeoffAccount/add',
            name: 'SCWriteoffAccountAdd',
            component: () => import('@/views/serverConfig/writeoffAccount/add'),
            meta: {
              title: '创建核销账户',
              activeMenu: '/serverConfig/writeoffAccount',
              breadcrumbTitle: '<span class="noblack">服务配置/核销账户<span class="black">/创建核销账户</span></span>',
              breadcrumbPathArr: [{
                class: 'noblack',
                path: '/serverConfig',
                name: '服务配置',
              },{
                class: 'noblack',
                path: '/serverConfig/writeoffAccount',
                name: '/核销账户'
              },{
                class: 'black',
                path: '/serverConfig/writeoffAccount/add',
                name: '/创建核销账户',
                name1: '/编辑核销账户',
                // 是否需要重新命名 比如创建 编辑2中情况 判断路由id
                isRedirectName: true
              }]
            },
            hidden: true
          },
        ]
      },
    ],
  },

  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
]

const createRouter = () =>
  new Router({
    mode: 'hash', // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  })

const router = createRouter()

export function resetRouter() {
  location.reload()
}

export default router
